export default __webpack_public_path__ + "static/media/info.cc44ec36.png";